export default __webpack_public_path__ + "static/media/pp-dropdown.30d54424.webp";